export default __webpack_public_path__ + "static/media/inprogress_icon.51a5aed3.png";